/**
 * Auto-lock after inactivity (spec §6.4; default 5 minutes, D61). Framework-free so the web app,
 * extension and mobile/desktop shells share it. The app calls touch() on user activity.
 */
export const AUTO_LOCK_CHOICES_MINUTES = [1, 5, 15, 30];
export const DEFAULT_AUTO_LOCK_MINUTES = 5;
export function isAutoLockMinutes(value) {
    return AUTO_LOCK_CHOICES_MINUTES.includes(value);
}
export class AutoLockTimer {
    timeoutMs;
    onLock;
    now;
    timer = null;
    deadline = 0;
    constructor(timeoutMs, onLock, now = Date.now) {
        this.timeoutMs = timeoutMs;
        this.onLock = onLock;
        this.now = now;
    }
    /** (Re)starts the countdown. */
    touch() {
        this.deadline = this.now() + this.timeoutMs;
        if (this.timer === null)
            this.schedule(this.timeoutMs);
    }
    setTimeoutMs(ms) {
        this.timeoutMs = ms;
        if (this.timer !== null)
            this.touch();
    }
    stop() {
        if (this.timer !== null)
            clearTimeout(this.timer);
        this.timer = null;
    }
    /**
     * Checks the deadline now (e.g. when the tab becomes visible again — browsers slow down timers
     * in background tabs, so a sleeping laptop could otherwise wake up unlocked).
     */
    check() {
        if (this.timer !== null && this.now() >= this.deadline)
            this.fire();
    }
    schedule(ms) {
        // One timer, re-armed only when it fires early (cheaper than resetting on every keystroke).
        this.timer = setTimeout(() => {
            this.timer = null;
            const left = this.deadline - this.now();
            if (left > 0)
                this.schedule(left);
            else
                this.fire();
        }, ms);
    }
    fire() {
        this.stop();
        this.onLock();
    }
}
//# sourceMappingURL=auto-lock.js.map